import { useCallback, useRef, useState } from 'react';

/** Ordenação que a lista manda de volta para a API (não só a página atual). */
export function useServerSort(initialKey, initialDir = 'asc') {
  const [orderBy, setOrderBy] = useState(initialKey);
  const [order, setOrder] = useState(initialDir);
  const orderByRef = useRef(initialKey);
  const orderRef = useRef(initialDir);

  const requestSort = useCallback((key) => {
    if (orderByRef.current === key) {
      const next = orderRef.current === 'asc' ? 'desc' : 'asc';
      orderRef.current = next;
      setOrder(next);
      return;
    }
    orderByRef.current = key;
    orderRef.current = 'asc';
    setOrderBy(key);
    setOrder('asc');
  }, []);

  return { orderBy, order, requestSort };
}
